import React from "react";

const O1O3Visa: React.FC = () => (
  <div className="max-w-7xl text-gray-900 text-left text-lg mx-auto px-10 pt-[100px] bg-white shadow-lg rounded-lg">
    <h1 className="text-3xl md:text-4xl font-extrabold text-[#0097b2] mb-4 leading-tight">O1/O3 visa (Extraordinary Ability)</h1>
    <div className="text-[22px] text-gray-700 mb-4">This page is under construction.</div>
    </div>
 
);

export default O1O3Visa;
